import ENDPOINTS from '@/config/apiEndpoints';
import { ErrorInterface } from '@/interfaces';
import ApiService from '@/services/ApiService';
import { logError } from '@/utils/logger';
export const submitGeneralRating = async (
  ratingType: string,
  rating: number,
): Promise<void> => {
  try {
    await ApiService.post(ENDPOINTS.RATINGS, {
      ratingType,
      rating,
    });
  } catch (error: any) {
    logError(error, 'RatingsService.submitGeneralRating');
    const statusCode = error.response?.status || 500;
    const errorCode = error.response?.data?.errorCode || undefined;
    const errorMessage =
      error.response?.data?.errorMessage ||
      'An unexpected error occurred while submitting rating. Please try again later.';
    const details = error.response?.data?.details || error.message;
    const errorDetails: ErrorInterface = {
      statusCode,
      ...(errorCode && { errorCode }),
      errorMessage,
      details,
    };
    throw errorDetails;
  }
};
